import { AnalyticsProvider } from "../../contracts/analytics/analytics";
import mixpanel from "mixpanel-browser";
import CONFIG from "../../core/consts/config";
import { LoggerContract } from "../../contracts/logger/logger";
import AnalyticsEvents from "../../core/consts/analytics-events";

const GtmAnalyticsProvider: AnalyticsProvider = (
    logger: LoggerContract
) => ({
  track(event: AnalyticsEvents, context?: any) {
    window.dataLayer.push({event,...context})
  },
  reset() {
  },
  setup() {
    window.dataLayer= window.dataLayer || [];
  },
  identify(identifier: any) {
  },
});

export default GtmAnalyticsProvider;
